import $ from 'jquery';
import * as CONST from '../../common/utils/constants';
import Util from '../../common/utils/ui';

class Layout {
	constructor() {
		this.$body = $('body');
		this.$header = $('.header');
		this.$hiddenHeader = $('.js-top-target');

		this.$nav = $('.nav-wrapper');
		this.$primaryNavItem = $('.primary-nav > li');
		this.$primaryNavItemLink = $('.primary-nav > li > a');
        this.$navToggle = $('.js-nav-toggle');
        this.$navToggleLabel = $('.js-nav-toggle-label');
		this.$navToggleChildren = $('.js-nav-toggle-children');

		this.$headerSearchTextbox = $('.js-search-textbox');

		this.didScroll = false;
		this.lastScrollTop = 0;
		this.delta = 5;

		this.$footerAccordionItem = $('.js-footer-accordion > .footer-column-navigation-item--parent > a');

        this.timer = 0;

        this.$menuButton = $('.js-menu-icon');
        this.$menuIcon = '<svg aria-hidden="true" data-prefix="far" data-icon="bars" class="svg-inline--fa fa-bars fa-w-14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M436 124H12c-6.627 0-12-5.373-12-12V80c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12z"/></svg>';
        this.$closeIcon = '<svg aria-hidden="true" data-prefix="far" data-icon="times" class="svg-inline--fa fa-times fa-w-10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"/></svg>';
    }

    init() {
        this.bindEvents();
		this.scrollHeaderEvents();
    }

	scrollHeaderEvents() {
		$(window).scroll(() => {
			if ($(window).scrollTop() > 20) {
				this.$header.addClass('scroll-active');
			} else {
				this.$header.removeClass('scroll-active');
			}
		});
	}

    bindEvents() {
		this.$navToggle.on('click', e => { e.preventDefault(); this.toggleNav(e); });

		this.$navToggleChildren.on('click', e => { this.mobileNavItem(e); });

		//$('body').on('click', e => { this.collapseSearch(e); });
		$('.close-search').on('click', e => { e.preventDefault(); this.collapseSearch(e); });

		// on focus header search
		$('.nav-item-searchbar').on('click', e => { e.preventDefault(); $('#app-search-input').focus(); this.toggleSearch(e); });

		$('.header .search').on('click', e => { e.stopPropagation(); });


		// on header search form submit
		$('.js-search-form').on('submit', e => { e.preventDefault(); window.location.href = `/search?query=${$('#app-search-input')[0].value}`; });

		// on menu enter
		this.$primaryNavItemLink.on('keydown', e => { this.tabbingNav(e); });

        this.$footerAccordionItem.on('click', e => { e.preventDefault(); this.footerAccordion(e); });

		// open megamenu on hover for desktop
		this.$primaryNavItem.on('mouseover', e => {
			clearTimeout(this.timer);
			$('.js-nav-megamenu').removeClass('open');

			this.openSubmenu(e);
		}).on('mouseleave', e => {
			this.timer = setTimeout(() => {
				this.closeSubmenu(e);
			}, 300);
		});

		// Hide Header on on scroll down
		$(window).scroll(e => {
			this.didScroll = true;
		});

		setInterval(() => {
			if (this.didScroll) {
				this.didScroll = false;
			}
        }, 100);
		
		//Scrolls back to the top after tabbing through page
		
		this.$hiddenHeader.focus(() => {
			window.scroll({
				top: 0, 
				left: 0, 
				behavior: 'smooth'
			});
		});
        //---/ Footer
	}

	closeSubmenu(e) {
		const target = $(e.currentTarget);

		$(target).closest('li').find('.js-nav-megamenu').removeClass('open');
	}

	toggleSearch(e) {
		const expandedSearch = $('.expanded-search');
		expandedSearch.toggleClass('hidden-search');
		const mobileHeaderIcon = $('.nav-item-searchbar>.far');
		mobileHeaderIcon.toggleClass('fa-search');
		mobileHeaderIcon.toggleClass('fa-times');
	}

	expandSearch(e) {
		$('.expanded-search').removeClass('hidden-search');

		const mobileHeaderIcon = $('.nav-item-searchbar>.far');
		mobileHeaderIcon.removeClass('fa-search');
		mobileHeaderIcon.addClass('fa-times');

		
		if (Util.getViewPort() === CONST.ViewPort.Desktop) {
			let target = e.currentTarget;
			let parent = $(target).closest('.search');

			$(parent).addClass('focused');
			$(target).val($(target).data('value'));
		}
	}

	collapseSearch(e) {
		$('.expanded-search').addClass('hidden-search');

		const mobileHeaderIcon = $('.nav-item-searchbar>.far');
		mobileHeaderIcon.removeClass('fa-search');
		mobileHeaderIcon.addClass('fa-times');

		if ($('.header .search').hasClass('focused') && !$('#header-search').is(':focus')) {
			$('.header .search').removeClass('focused');
			$('#header-search').data('value', $('.header .search .form-control').val());  
			$('#header-search').val(''); 
		} 
	}

	// clicking on items in mobile nav
	mobileNavItem(e) {
		if (Util.getViewPort() !== CONST.ViewPort.Desktop) {
			e.preventDefault();

			const target = $(e.currentTarget);
			const parent = target.closest('li');

			$(parent).find('> ul').slideToggle();
			$(parent).toggleClass('open');
		}
	}

	openSubmenu(e) {
		const target = $(e.currentTarget);

		$(target).closest('li').find('.js-nav-megamenu').addClass('open');
	}

	// if user hits enter when tabbing on menu items, open mega menu and set tabbing to children
	tabbingNav(e) {
		let target = $(e.currentTarget);

		if (e.keyCode === 13 && target.hasClass('has-dropdown')) {
			e.preventDefault();
			target.closest('li').addClass('focused');
			if (target.closest('li').find('.js-nav-megamenu').hasClass('open')) {
				// if the dropdown is open, hitting enter again on the parent link should take them to that link.
				window.location.href = e.target.getAttribute('href');
			} else {
				target.closest('li').find('.js-nav-megamenu').addClass('open');
			}
		}

		let $activeElem = $(document.activeElement);
		let $prevItem = $activeElem.closest('li').prev();

		if ($prevItem.hasClass('focused')) {
			$prevItem.removeClass('focused');
			$prevItem.find('.js-nav-megamenu').removeClass('open');
		}

		if (e.shiftKey && (e.keyCode === 9)) {
			$('.js-nav-megamenu').removeClass('open');
		}
	}

	// toggle nav on mobile
	toggleNav(e) {
		e.preventDefault();
		$('.js-nav-megamenu').removeAttr('style').closest('li').removeClass('open'); // Open nav with sub menus closed

		if ($(window).width() < 992)
		{
			$('.js-nav-toggle').toggleClass('open');
			const header = $('.header');
			const headerHeight = header[0].offsetHeight;
			// $('.nav-wrapper').css('top', headerHeight);
		}

		this.$nav.slideToggle().toggleClass('open');
        this.$body.toggleClass('nav-open');
	}

    // Footer accordion expand/collapse
    footerAccordion(e) {
        const target = $(e.currentTarget);

		if (Util.getViewPort() !== CONST.ViewPort.Desktop) {
            target.parent().toggleClass('open');
			target.siblings('.footer-column-navigation-sub').slideToggle();
        }
		else {
			let href = $(target).attr('href');
			window.location = href;
		}        
    }
}

export default Layout;